export default __webpack_public_path__ + "static/media/8d5476a0ea9334a9.6111419b7459176c640d2dbb38397033.svg";